import { useSite } from '../../contexts/SiteContext';
import { euro } from '../../core/format/currency';

/** De cadeautreden onder elkaar: bedrag links, cadeau rechts. Gedeeld door home en protocollen. */
export function GiftTierList({
  className = 'mt-4'
}: {
  className?: string;
}) {
  const {
    giftTiers
  } = useSite();
  if (giftTiers.length === 0) return null;
  return <ul className={`${className} divide-y divide-line border-y border-line`} aria-label="Cadeaus bij je bestelling" data-id="element-8233" data-mp="2gjzk25krn7c7">
      {giftTiers.map(tier => <li key={tier.threshold} className="flex gap-4 py-3.5" data-id="element-8234" data-mp="26twivi3hqn2s">
          <span className="w-14 shrink-0 font-display text-lg text-clay" data-id="element-8235" data-mp="26slat630it5v">
            <span className="sr-only" data-id="element-8236" data-mp="22t2rufur4s5o">Vanaf </span>
            {euro(tier.threshold)}
          </span>
          <span className="text-[14px] leading-snug text-muted" data-id="element-8237" data-mp="1xvkt1iag7tbe">
            <span className="block text-ink" data-id="element-8238" data-mp="1stlnq2v5embt">{tier.title}</span>
            {tier.description}
          </span>
        </li>)}
    </ul>;
}